<template>
  <el-container>
    <el-main id="el-main">
      <Top3QaRecommend title="您好，欢迎使用优行关爱小助手！您可以直接点击以下<b>【热门问题】</b>进行咨询。" />
      <ChatbotWelcome message="若想咨询<b>【更多问题】</b>，欢迎您选择问题类型按钮或直接在对话框输入关键字搜索问题。"></ChatbotWelcome>
      <ChatbotService />
      <ContainerMapper :message-list='messageList' />
    </el-main>
    <el-footer><ChatbotFooter /></el-footer>
  </el-container>
</template>

<script>
import ChatbotWelcome from '@/components/Welcome'
import ChatbotFooter from '@/components/Footer'
import ContainerMapper from '@/components/ContainerMapper'
import ChatbotService from '@/components/Service'
import Top3QaRecommend from '@/components/Top3QaRecommend'

export default {
  name: "chatBot",
  components: {
    ChatbotWelcome,
    ChatbotFooter,
    ContainerMapper,
    ChatbotService,
    Top3QaRecommend,
  },
  data() {
    return {
      showServiceListOrder: 0,
      selectedItem:'',
    };
  },
   mounted() {
  },
  computed: {
    messageList() {
      // console.log('消息列表发生了变化');
      const lastIndex = []
      const message = this.$store.getters.get_messageList
      const len = message.length;
      for (let i=len-1; i >= 0;) {
        const {over, isMultiQuestion} = message[i]
        if (over || isMultiQuestion) {
          lastIndex.push(i)
        }
        i--
      }
      const indexLen = lastIndex.length;
      if(indexLen == 1){
        message[lastIndex[0]].lastItem = true
      } else if (indexLen > 1){
        message[lastIndex[0]].lastItem = true
        for (let j = 1; j < indexLen; j++) {
          message[lastIndex[j]].lastItem = false
        }
      }
      return message
    }
  },
};
</script>
<style>
body{
  width: 390px;
  min-width: 320px;
  max-width: 640px;
}
#el-main{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  flex-grow: 1;
  height: calc(100vh - 60px);
  padding:20px 10px 10px;
}
</style>
